(function(){
/* Nov 2 2026: Parade Marshal deck engine v2. Smooth on every input: mouse drag, trackpad swipe and pinch, mouse wheel, touch swipe and pinch, keys.
   Only transform and opacity ever animate (no blur, no moving pivots), every picture is loaded and decoded before it is needed,
   and quick repeated swipes are never dropped. Full screen: swipe between marshals, pinch or double tap to zoom, drag to look around. */
if (window.ParadeDeck) return;
var EASE = 'cubic-bezier(.22,1,.36,1)';
var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
var FINE = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
var FAN = function(){ return window.innerWidth < 600 ? 0.42 : 0.62; };
var ORIGIN = '50% 165%';
var OUT = 'translate3d(-128%,-5%,0) rotate(-17deg)';
function pad(n){ return n < 10 ? '0' + n : '' + n; }
function now(){ return performance.now(); }
function dur(s){ return REDUCED ? '.01s' : s; }
function abs(u){ try { return new URL(u, location.href).href; } catch(e){ return u; } }

/* one wheel / trackpad reader shared by the deck and the full-screen view:
   a flick = one step, its momentum tail is swallowed, a new flick during the tail still counts, each mouse-wheel notch is one step */
function Wheel(step){
  var lock = false, quiet = 0, acc = 0, peak = 0, low = 1e9, lastT = 0, stepT = 0;
  return function(e){
    var dx = e.deltaX, dy = e.deltaY, t = now(), gap = t - lastT; lastT = t;
    if (e.deltaMode === 1) { dx *= 16; dy *= 16; }
    var d = Math.abs(dx) > Math.abs(dy) ? dx : dy, a = Math.abs(d);
    clearTimeout(quiet); quiet = setTimeout(function(){ lock = false; acc = 0; peak = 0; low = 1e9; }, 180);
    /* a mouse-wheel click arrives on its own (a pause before it) as one big whole number; a trackpad sends a steady stream */
    var notch = e.deltaMode === 1 || (gap > 90 && dx === 0 && a >= 50 && a === Math.round(a));
    if (notch && !(lock && t - stepT < 200)) { stepT = t; lock = true; peak = a; low = a; acc = 0; step(d > 0 ? 1 : -1); return; }
    if (lock) {
      if (a < low) low = a;
      if (a > peak && low > peak * 0.8) peak = a;
      /* only a clearly new flick, after the glide has nearly died, may move again */
      if (t - stepT > 380 && low < peak * 0.25 && a > Math.max(24, low * 4)) { lock = false; acc = 0; }
      else return;
    }
    acc += d;
    if (Math.abs(acc) > 30) { lock = true; stepT = t; peak = a; low = a; step(acc > 0 ? 1 : -1); acc = 0; }
  };
}

/* ---------- full-screen view ---------- */
var V = null;
function viewer(){
  if (V) return V;
  var ov = document.createElement('div');
  ov.className = 'pmd-ov';
  ov.setAttribute('role', 'dialog');
  ov.setAttribute('aria-modal', 'true');
  ov.setAttribute('aria-label', 'Parade Marshal card');
  ov.innerHTML = '<div class="pmd-ov__bg"></div><div class="pmd-ov__stage"><img class="pmd-ov__card" alt="" draggable="false"></div>' +
    '<button type="button" class="pmd-ov__nav pmd-ov__prev" aria-label="Previous marshal"><svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg></button>' +
    '<button type="button" class="pmd-ov__nav pmd-ov__next" aria-label="Next marshal"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button>' +
    '<button type="button" class="pmd-ov__x" aria-label="Close"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button>';
  document.body.appendChild(ov);
  V = { ov: ov, stage: ov.querySelector('.pmd-ov__stage'), img: ov.querySelector('.pmd-ov__card'), x: ov.querySelector('.pmd-ov__x'),
        deck: null, i: 0, s: 1, tx: 0, ty: 0, box: null, busy: false };
  var img = V.img, stage = V.stage;

  function apply(anim){
    stage.style.transition = anim ? 'transform ' + dur('.32s ') + EASE : 'none';
    stage.style.transform = 'translate3d(' + V.tx + 'px,' + V.ty + 'px,0) scale(' + V.s + ')';
    ov.classList.toggle('is-zoomed', V.s > 1.01);
  }
  function clamp(){
    var b = V.box, W = b.W * V.s, H = b.H * V.s, vw = innerWidth, vh = innerHeight;
    var minX = Math.min(0, vw - W) - b.L, maxX = Math.max(0, vw - W) - b.L;
    var minY = Math.min(0, vh - H) - b.T, maxY = Math.max(0, vh - H) - b.T;
    if (W <= vw) { V.tx = (vw - W) / 2 - b.L; } else { V.tx = Math.min(maxX, Math.max(minX, V.tx)); }
    if (H <= vh) { V.ty = (vh - H) / 2 - b.T; } else { V.ty = Math.min(maxY, Math.max(minY, V.ty)); }
  }
  function zoomAt(f, cx, cy, anim){
    var s0 = V.s, s1 = Math.min(4, Math.max(1, s0 * f));
    if (s1 === s0) return;
    var px = cx - V.box.L, py = cy - V.box.T;
    V.tx = px - (px - V.tx) * s1 / s0;
    V.ty = py - (py - V.ty) * s1 / s0;
    V.s = s1;
    if (s1 <= 1.001) { V.s = 1; V.tx = 0; V.ty = 0; } else clamp();
    if (anim === 'frame') { ov.classList.toggle('is-zoomed', V.s > 1.01); sched(); } else apply(anim);
  }
  V.reset = function(anim){ V.s = 1; V.tx = 0; V.ty = 0; apply(anim); };
  V.zoomAt = zoomAt;

  /* swipe to the next / previous marshal inside the full-screen view */
  V.go = function(dir){
    var d = V.deck; if (!d || d.n < 2 || V.busy) return;
    if (V.s > 1.01) { V.reset(true); return; }
    V.busy = true;
    var ni = (V.i + dir + d.n) % d.n, w = innerWidth;
    var src = d.thumb(ni);
    img.style.transition = 'transform ' + dur('.26s') + ' cubic-bezier(.4,0,1,1), opacity ' + dur('.26s') + ' ease';
    img.style.transform = 'translate3d(' + (-dir * w * 0.6) + 'px,0,0) rotate(' + (-dir * 4) + 'deg)';
    img.style.opacity = '0';
    var swap = function(){
      V.i = ni;
      d.sync(ni);
      img.src = src; img.alt = d.alt(ni);
      img.style.transition = 'none';
      img.style.transform = 'translate3d(' + (dir * w * 0.6) + 'px,0,0) rotate(' + (dir * 4) + 'deg)';
      void img.offsetWidth;
      img.style.transition = 'transform ' + dur('.42s ') + EASE + ', opacity ' + dur('.3s') + ' ease';
      img.style.transform = 'none';
      img.style.opacity = '1';
      setTimeout(function(){ V.busy = false; }, REDUCED ? 10 : 200);
      d.upgrade(ni, function(u){ if (V.i === ni && d.isOpen) img.src = u; });
    };
    setTimeout(swap, REDUCED ? 10 : 230);
  };

  /* pointers: drag to swipe, two fingers to pinch, drag to pan when zoomed, double tap / double click to zoom.
     the numbers change at once; the picture is redrawn once per screen frame */
  var pts = new Map(), g = null, lastTap = 0, lastTapX = 0, lastTapY = 0, raf = 0, imgT = null;
  function frame(){ raf = 0; if (imgT !== null) { img.style.transform = imgT; imgT = null; } else apply(false); }
  function sched(){ if (!raf) raf = requestAnimationFrame(frame); }
  ov.addEventListener('pointerdown', function(e){
    if (e.target.closest('button')) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    try { ov.setPointerCapture(e.pointerId); } catch(_) {}
    if (pts.size === 2) {
      var a = Array.from(pts.values());
      g = { pinch: true, d0: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1, s0: V.s, tx0: V.tx, ty0: V.ty,
            cx: (a[0].x + a[1].x) / 2, cy: (a[0].y + a[1].y) / 2 };
      img.style.transition = 'none'; imgT = null; img.style.transform = 'none';
      return;
    }
    if (pts.size === 1) {
      g = { sx: e.clientX, sy: e.clientY, tx0: V.tx, ty0: V.ty, moved: false, t0: now(), onCard: e.target === img, lx: e.clientX, lt: now(), vx: 0 };
      stage.style.transition = 'none'; img.style.transition = 'none';
    }
  });
  ov.addEventListener('pointermove', function(e){
    if (!pts.has(e.pointerId) || !g) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (g.pinch && pts.size >= 2) {
      var a = Array.from(pts.values()), dd = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), cx = (a[0].x + a[1].x) / 2, cy = (a[0].y + a[1].y) / 2;
      var s1 = Math.min(4, Math.max(1, g.s0 * dd / g.d0));
      var px = g.cx - V.box.L, py = g.cy - V.box.T;
      V.s = s1;
      V.tx = px - (px - g.tx0) * s1 / g.s0 + (cx - g.cx);
      V.ty = py - (py - g.ty0) * s1 / g.s0 + (cy - g.cy);
      if (s1 > 1.001) clamp(); else { V.tx = 0; V.ty = 0; }
      ov.classList.toggle('is-zoomed', V.s > 1.01);
      sched();
      return;
    }
    var dx = e.clientX - g.sx, dy = e.clientY - g.sy, t = now();
    if (!g.moved && Math.hypot(dx, dy) > 6) g.moved = true;
    if (t > g.lt) { g.vx = 0.6 * g.vx + 0.4 * (e.clientX - g.lx) / (t - g.lt); }
    g.lx = e.clientX; g.lt = t;
    if (!g.moved) return;
    if (V.s > 1.01) { V.tx = g.tx0 + dx; V.ty = g.ty0 + dy; clamp(); sched(); }
    else if (!V.busy) { imgT = 'translate3d(' + dx + 'px,' + (dy * 0.15) + 'px,0) rotate(' + (dx * 0.02) + 'deg)'; sched(); }
  });
  function up(e){
    if (!pts.has(e.pointerId)) return;
    pts.delete(e.pointerId);
    if (!g) return;
    if (g.pinch) { if (pts.size === 0) { g = null; if (V.s < 1.02) V.reset(true); } else { var p = Array.from(pts.values())[0]; g = { sx: p.x, sy: p.y, tx0: V.tx, ty0: V.ty, moved: true, t0: now(), lx: p.x, lt: now(), vx: 0 }; } return; }
    var G = g; g = null; imgT = null;
    var dx = e.clientX - G.sx;
    if (!G.moved) {
      var t = now();
      if (t - lastTap < 320 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
        lastTap = 0;
        if (V.s > 1.01) V.reset(true); else zoomAt(2.4, e.clientX, e.clientY, true);
        return;
      }
      lastTap = t; lastTapX = e.clientX; lastTapY = e.clientY;
      if (!G.onCard && V.s <= 1.01) { var at = t; setTimeout(function(){ if (lastTap === at && V.deck) V.deck.close(); }, 330); }
      return;
    }
    if (V.s > 1.01) return;
    img.style.transition = 'transform ' + dur('.36s ') + EASE;
    if (dx < -innerWidth * 0.12 || G.vx < -0.45) V.go(1);
    else if (dx > innerWidth * 0.12 || G.vx > 0.45) V.go(-1);
    else img.style.transform = 'none';
  }
  ov.addEventListener('pointerup', up);
  ov.addEventListener('pointercancel', up);

  var wheelStep = Wheel(function(dir){ V.go(dir); });
  ov.addEventListener('wheel', function(e){
    e.preventDefault(); e.stopPropagation();
    if (!V.deck) return;
    if (e.ctrlKey) { zoomAt(Math.exp(-e.deltaY * (e.deltaMode === 1 ? 0.05 : 0.01)), e.clientX, e.clientY, 'frame'); return; }
    if (V.s > 1.01) { var dx = e.deltaX, dy = e.deltaY; if (e.deltaMode === 1) { dx *= 16; dy *= 16; } V.tx -= dx; V.ty -= dy; clamp(); sched(); return; }
    wheelStep(e);
  }, { passive: false });
  ['gesturestart', 'gesturechange'].forEach(function(t){ ov.addEventListener(t, function(e){ e.preventDefault(); }, { passive: false }); });
  ov.addEventListener('dblclick', function(e){ e.preventDefault(); });
  ['mousedown', 'touchstart', 'touchmove'].forEach(function(t){ ov.addEventListener(t, function(e){ e.stopPropagation(); }, { passive: true }); });
  ov.addEventListener('touchmove', function(e){ e.preventDefault(); }, { passive: false });

  V.x.addEventListener('click', function(e){ e.stopPropagation(); if (V.deck) V.deck.close(); });
  ov.querySelector('.pmd-ov__prev').addEventListener('click', function(e){ e.stopPropagation(); V.go(-1); });
  ov.querySelector('.pmd-ov__next').addEventListener('click', function(e){ e.stopPropagation(); V.go(1); });
  document.addEventListener('keydown', function(e){
    if (!V.deck || !V.deck.isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); V.deck.close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); V.go(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); V.go(-1); }
  });
  window.addEventListener('resize', function(){ if (V.deck && V.deck.isOpen) { V.box = V.deck.target(); var b = V.box; stage.style.left = b.L + 'px'; stage.style.top = b.T + 'px'; stage.style.width = b.W + 'px'; stage.style.height = b.H + 'px'; V.reset(false); } });
  return V;
}

/* ---------- the deck ---------- */
function Deck(root){
  this.root = root;
  this.wrap = root.closest('.pmd-wrap') || root.parentNode;
  this.cards = [].slice.call(root.querySelectorAll('.pmd__card'));
  this.n = this.cards.length;
  this.order = this.cards.map(function(_, i){ return i; });
  this.count = this.wrap.querySelector('.pmd__count');
  this.isOpen = false;
  this.timers = {};
  this.fulls = {};
  if (!this.n) return;
  /* Speed step 2 (Nov 3 2026): the card pictures wait until the deck is opened, or until the world is calm on a good line */
  var held = [];
  this.cards.forEach(function(c){ c.style.transformOrigin = ORIGIN; var im = c.querySelector('img'); if (im) { im.decoding = 'async'; if (!(im.complete && im.naturalWidth)) { var ss = im.getAttribute('srcset'), sr = im.getAttribute('src'); if (ss) { im.setAttribute('data-pmd-srcset', ss); im.removeAttribute('srcset'); } if (sr) { im.setAttribute('data-pmd-src', sr); im.removeAttribute('src'); } held.push(im); } else im.loading = 'eager'; } });
  this.held = held;
  this.bind();
  this.layout(true);
  this.hold();
}
var P = Deck.prototype;

P.img = function(i){ return this.cards[i].querySelector('img'); };
P.thumb = function(i){ var im = this.img(i); return im.currentSrc || im.src; };
P.alt = function(i){ return this.img(i).alt || ''; };
P.full = function(i){ return abs(this.cards[i].getAttribute('data-full') || this.thumb(i)); };
P.upgrade = function(i, cb){
  var self = this, u = this.full(i);
  if (this.fulls[u] === true) { cb(u); return; }
  var im = new Image(); im.decoding = 'async'; im.src = u;
  (im.decode ? im.decode() : new Promise(function(r){ im.onload = r; })).then(function(){ self.fulls[u] = true; cb(u); }, function(){});
};

/* load and decode every card picture ahead of time, then quietly fetch the full-screen pictures one by one */
P.release = function(){
if (!this.held || !this.held.length) return; var list = this.held; this.held = null;
list.forEach(function(im){ im.loading = 'eager'; var ss = im.getAttribute('data-pmd-srcset'), sr = im.getAttribute('data-pmd-src'); if (ss) im.setAttribute('srcset', ss); if (sr) im.setAttribute('src', sr); });
this.warm();
};
P.hold = function(){
var self = this;
if (!this.held || !this.held.length) { this.warm(); return; }
var rel = function(){ self.release(); }; if (window.PQ && window.PQ.addWarm) window.PQ.addWarm(rel);
if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function(es){ if (es.some(function(e){ return e.isIntersecting; })) { io.disconnect(); rel(); } }); io.observe(this.root); } else { rel(); return; }
this.root.addEventListener('pointerdown', rel, { once: true, capture: true });
var calm = function(){ if (window.PQ && window.PQ.lite) return; if (window.PQ && window.PQ.still) window.PQ.still(rel); else setTimeout(rel, 2500); };
if (document.readyState === 'complete') calm(); else window.addEventListener('load', calm);
};
P.warm = function(){
  var self = this;
  var go = function(){ self.cards.forEach(function(c){ var im = c.querySelector('img'); if (im && im.decode) im.decode().catch(function(){}); }); };
  if (document.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', function(){ setTimeout(go, 300); });
};
P.warmFull = function(){
  if (this.__wf) return; this.__wf = true;
  var self = this, list = this.order.slice(), k = 0;
  var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 200); };
  (function nextOne(){
    if (k >= list.length) return;
    var i = list[k++];
    idle(function(){ self.upgrade(i, function(){}); setTimeout(nextOne, 250); });
  })();
};

P.place = function(c, pos, instant){
  var k = Math.min(pos, 7);
  c.style.transition = instant ? 'none' : 'transform ' + dur('.42s ') + EASE + ', opacity ' + dur('.3s') + ' ease';
  c.style.zIndex = String(this.n - pos);
  c.style.transform = pos ? 'rotate(' + (k * FAN()).toFixed(2) + 'deg)' : 'none';
  c.style.opacity = pos > 7 ? '0' : '1';
  c.style.setProperty('--pmd-shade', pos ? (0.1 + k * 0.05).toFixed(2) : '0');
  c.setAttribute('aria-hidden', pos ? 'true' : 'false');
};

P.layout = function(instant, skip){
  var self = this;
  this.order.forEach(function(ci, pos){ var c = self.cards[ci]; if (c !== skip) self.place(c, pos, instant); });
  if (this.count) this.count.textContent = pad(this.order[0] + 1) + ' / ' + pad(this.n);
};

P.next = function(){
  if (this.n < 2 || this.isOpen) return;
  var self = this, ci = this.order[0], c = this.cards[ci];
  clearTimeout(this.timers[ci]);
  c.style.transition = 'transform ' + dur('.32s') + ' cubic-bezier(.4,0,.8,.45), opacity .2s ease';
  c.style.zIndex = String(this.n + 1);
  c.style.transform = OUT;
  this.order.push(this.order.shift());
  this.layout(false, c);
  this.timers[ci] = setTimeout(function(){ var pos = self.order.indexOf(ci); c.style.zIndex = '0'; self.place(c, pos, false); }, REDUCED ? 10 : 280);
};

P.prev = function(){
  if (this.n < 2 || this.isOpen) return;
  var ci = this.order.pop(), c = this.cards[ci];
  clearTimeout(this.timers[ci]);
  this.order.unshift(ci);
  c.style.transition = 'none';
  c.style.zIndex = String(this.n + 1);
  c.style.opacity = '1';
  c.style.transform = OUT;
  void c.offsetWidth;
  this.layout(false);
};

P.goTo = function(i, instant){
  if (i < 0 || i >= this.n) return;
  var guard = 0;
  while (this.order[0] !== i && guard++ < this.n) this.order.push(this.order.shift());
  for (var k in this.timers) clearTimeout(this.timers[k]);
  this.layout(!!instant);
};
P.sync = function(i){ this.goTo(i, true); };

P.bind = function(){
  var self = this, root = this.root, drag = null, raf = 0;
  root.tabIndex = 0;
  root.setAttribute('role', 'group');
  root.setAttribute('aria-roledescription', 'card deck');
  ['pointerdown','pointermove','pointerup','mousedown','touchstart','touchmove','wheel'].forEach(function(t){
    root.addEventListener(t, function(e){ e.stopPropagation(); }, { passive: true });
  });
  root.addEventListener('dragstart', function(e){ e.preventDefault(); });

  function paint(){
    raf = 0; if (!drag) return;
    var d = drag;
    d.c.style.transform = 'translate3d(' + d.dx + 'px,' + (d.dy * 0.12) + 'px,0) rotate(' + (d.dx * 0.03) + 'deg)';
    if (self.n > 1) {
      var nc = self.cards[self.order[1]], p = d.dx < 0 ? Math.min(-d.dx / d.w, 1) : 0;
      nc.style.transition = 'none';
      nc.style.transform = 'rotate(' + (FAN() * (1 - p)).toFixed(2) + 'deg)';
      nc.style.setProperty('--pmd-shade', (0.15 * (1 - p)).toFixed(2));
    }
  }

  root.addEventListener('pointerdown', function(e){
    if (self.isOpen || (e.button && e.button !== 0)) return;
    var c = e.target.closest('.pmd__card');
    if (!c || c !== self.cards[self.order[0]]) return;
    clearTimeout(self.timers[self.order[0]]);
    drag = { c: c, sx: e.clientX, sy: e.clientY, lx: e.clientX, lt: now(), t0: now(), dx: 0, dy: 0, vx: 0, w: c.offsetWidth, id: e.pointerId };
    try { c.setPointerCapture(e.pointerId); } catch (_) {}
    c.style.transition = 'none';
  });
  root.addEventListener('pointermove', function(e){
    if (!drag || e.pointerId !== drag.id) return;
    var t = now();
    drag.dx = e.clientX - drag.sx;
    drag.dy = e.clientY - drag.sy;
    if (t > drag.lt) drag.vx = 0.6 * drag.vx + 0.4 * ((e.clientX - drag.lx) / (t - drag.lt));
    drag.lx = e.clientX; drag.lt = t;
    if (!raf) raf = requestAnimationFrame(paint);
  });
  function end(e){
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag; drag = null;
    try { d.c.releasePointerCapture(d.id); } catch (_) {}
    var moved = Math.abs(d.dx) > 6 || Math.abs(d.dy) > 6;
    if (!moved && now() - d.t0 < 500) { self.layout(); self.open(); return; }
    if (d.dx < -d.w * 0.25 || d.vx < -0.45) self.next();
    else if (d.dx > d.w * 0.25 || d.vx > 0.45) self.prev();
    else self.layout();
  }
  root.addEventListener('pointerup', end);
  root.addEventListener('pointercancel', end);

  var step = Wheel(function(dir){ if (dir > 0) self.next(); else self.prev(); });
  root.addEventListener('wheel', function(e){
    if (self.isOpen) return;
    e.preventDefault();
    if (e.ctrlKey) return; /* a pinch on the deck never zooms the whole page */
    step(e);
  }, { passive: false });
  ['gesturestart', 'gesturechange'].forEach(function(t){ root.addEventListener(t, function(e){ e.preventDefault(); }, { passive: false }); });

  root.addEventListener('keydown', function(e){
    if (self.isOpen) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.open(); }
  });

  var bp = this.wrap.querySelector('[data-pmd-prev]'), bn = this.wrap.querySelector('[data-pmd-next]');
  if (bp) bp.addEventListener('click', function(e){ e.stopPropagation(); self.prev(); });
  if (bn) bn.addEventListener('click', function(e){ e.stopPropagation(); self.next(); });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting) { self.warmFull(); io.disconnect(); } }); });
    io.observe(root);
  }
};

P.target = function(){
  var vw = window.innerWidth, vh = window.innerHeight, m = vw < 600 ? 14 : 28;
  var H = Math.min(vh - m * 2 - (vw < 600 ? 40 : 0), (vw - m * 2) * 7 / 5), W = H * 5 / 7;
  return { W: W, H: H, L: (vw - W) / 2, T: (vh - H) / 2 };
};

P.open = function(){
  if (this.isOpen) return;
  var v = viewer();
  if (v.deck && v.deck.isOpen) return;
  var ci = this.order[0], c = this.cards[ci];
  var r = c.getBoundingClientRect(), t = this.target();
  this.isOpen = true; v.deck = this; v.i = ci; v.box = t; v.busy = false;
  this.warmFull();
  var img = v.img, stage = v.stage;
  img.src = this.thumb(ci); img.alt = this.alt(ci);
  img.style.transition = 'none'; img.style.transform = 'none'; img.style.opacity = '1';
  stage.style.cssText = 'left:' + t.L + 'px;top:' + t.T + 'px;width:' + t.W + 'px;height:' + t.H + 'px;transition:none;transform:translate3d(' + (r.left - t.L) + 'px,' + (r.top - t.T) + 'px,0) scale(' + (r.width / t.W) + ')';
  v.s = 1; v.tx = 0; v.ty = 0;
  v.ov.classList.remove('is-zoomed');
  v.ov.classList.toggle('pmd-ov--fine', FINE && this.n > 1);
  v.ov.style.display = 'block';
  c.style.visibility = 'hidden';
  void stage.offsetWidth;
  v.ov.classList.add('is-open');
  stage.style.transition = 'transform ' + dur('.55s ') + EASE;
  stage.style.transform = 'none';
  this.upgrade(ci, function(u){ if (v.deck && v.deck.isOpen && v.i === ci) img.src = u; });
  setTimeout(function(){ try { v.x.focus({ preventScroll: true }); } catch(_) {} }, 50);
};

P.close = function(){
  if (!this.isOpen || !V) return;
  var self = this, v = V, c = this.cards[this.order[0]];
  this.cards.forEach(function(k){ k.style.visibility = ''; });
  c.style.visibility = 'hidden';
  var r = c.getBoundingClientRect(), t = v.box;
  v.ov.classList.remove('is-open');
  v.img.style.transition = 'none'; v.img.style.transform = 'none'; v.img.style.opacity = '1';
  v.stage.style.transition = 'transform ' + dur('.45s ') + EASE;
  v.stage.style.transform = 'translate3d(' + (r.left - t.L) + 'px,' + (r.top - t.T) + 'px,0) scale(' + (r.width / t.W) + ')';
  setTimeout(function(){
    c.style.visibility = '';
    v.ov.style.display = 'none';
    self.isOpen = false; v.deck = null;
    try { self.root.focus({ preventScroll: true }); } catch(_) {}
  }, REDUCED ? 20 : 450);
};

window.ParadeDeck = Deck;
window.ParadeDeck.init = function(scope){
  [].slice.call((scope || document).querySelectorAll('.pmd')).forEach(function(el){
    if (!el.__pmd) el.__pmd = new Deck(el);
  });
};
})();

(function(){
  var SID = window.__PMD_SID;

  function deckWidth(w){
    return Math.round(Math.min(w, window.innerWidth * 0.72, (window.innerHeight - 300) * 5 / 7));
  }

  function mount(){
    var src = document.getElementById('pmd-src-' + SID);
    if (!src || !(+src.getAttribute('data-count'))) return;
    var key = src.getAttribute('data-window') || 'signboard';
    var w = +src.getAttribute('data-w') || 300;
    var wrap = src.querySelector('.pmd-wrap');
    var deck = wrap.querySelector('.pmd');
    var win = document.querySelector('.pw-win[data-window="' + key + '"]') || document.querySelector('[data-window="' + key + '"]:not(.pmd-src)');

    var host = win ? win.querySelector('.pmd-host') : null;
    function size(){
      var dw = deckWidth(w);
      deck.style.setProperty('--pmd-w', dw + 'px');
      if (win) { win.style.width = dw + 'px'; }
    }

    if (!win) {
      if (src.getAttribute('data-editor')) { src.hidden = false; src.classList.add('pmd-src--inline'); size(); ParadeDeck.init(src); }
      if (window.console) console.warn('[Parade Marshal Deck] No window with data-window="' + key + '" found.');
      return;
    }

    var sel = src.getAttribute('data-target');
    if (!host) {
      var inner = sel ? win.querySelector(sel) : null;
      host = document.createElement('div');
      host.className = 'pmd-host';
      if (inner) {
        [].slice.call(inner.children).forEach(function(ch){ ch.setAttribute('data-pmd-hidden', ''); ch.style.display = 'none'; });
        inner.appendChild(host);
      } else {
        [].slice.call(win.children).forEach(function(ch){
          var cls = (typeof ch.className === 'string' ? ch.className : (ch.getAttribute('class') || ''));
          var keep = /(^|[\s_-])(bar|head|header|top|title|close|back|drag|handle|chrome|foot|footer)([\s_-]|$)/i.test(cls) || ch.tagName === 'BUTTON';
          if (!keep) { ch.setAttribute('data-pmd-hidden', ''); ch.style.display = 'none'; }
        });
        win.appendChild(host);
      }
    }
    host.innerHTML = '';
    host.appendChild(wrap);
    win.classList.add('pmd-bare');
    var cx = wrap.querySelector('[data-pmd-close]');
    if (cx && !cx.__pmd) { cx.__pmd = 1; cx.addEventListener('pointerdown', function(e){ e.stopPropagation(); }); cx.addEventListener('click', function(e){ e.stopPropagation(); var b = win.querySelector('.pw-win__close'); if (b) b.click(); else win.hidden = true; }); }
    win.style.maxHeight = 'none';
    win.style.height = 'auto';
    size();
    ParadeDeck.init(host);
    if (!window.__pmdResize) {
      window.__pmdResize = true;
      var t;
      window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(size, 120); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();

  document.addEventListener('shopify:section:load', function(e){ if (e.detail && e.detail.sectionId === SID) mount(); });
  document.addEventListener('shopify:block:select', function(e){
    if (!e.detail || e.detail.sectionId !== SID) return;
    var card = document.querySelector('.pmd__card[data-block="' + e.detail.blockId + '"]');
    var deckEl = card && card.closest('.pmd');
    if (deckEl && deckEl.__pmd) deckEl.__pmd.goTo(deckEl.__pmd.cards.indexOf(card));
  });
})();
